import { DatePicker } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import "./DatePickerWithTime.scss";

dayjs.extend(utc);

const DatePickerWithTime = ({ value, onChange, disabled }) => {
  const handleChange = (date) => {
    if (date) {
      const formatted = date
        .format("MMMM D, YYYY, h:mm A")
        .replace("AM", "a.m.")
        .replace("PM", "p.m.");
   
    } else {
    
    }

    // Send UTC string back to parent only if not disabled
    onChange?.(date ? dayjs(date).utc().toISOString() : null);
  };

  return (
    <div className="date-picker-with-time">
      <DatePicker
        value={value} // value is already dayjs object
        showTime
        onChange={handleChange}
        format={(val) =>
          val
            ? val
                .format("MMMM D, YYYY, h:mm A")
                .replace("AM", "a.m.")
                .replace("PM", "p.m.")
            : ""
        }
        style={{ width: "100%" }}
        className="trigger-button"
        popupClassName="custom-date-picker-popup"
        allowClear
        disabled={disabled ?? true}
      />
    </div>
  );
};

export default DatePickerWithTime;
